(function ($) {
"use strict";

    // video_active
    $(".video_active").owlCarousel({
        autoplay:true,
        autoplayTimeout:15000,
        loop:true,
        items:1,
        dots:true,
        nav:false
    });

    // video_background
    //
    // GUARDED. This used to call jQuery("#bgndVideo").YTPlayer() unconditionally
    // and threw "jQuery(...).YTPlayer is not a function" as an uncaught
    // TypeError on EVERY page of the site.
    //
    // Cause: assets/jquery.mb.YTPlayer.min.css is loaded by theme.liquid, but
    // the matching plugin JS was never uploaded to the theme - only the
    // stylesheet exists. So $.fn.YTPlayer has never been defined.
    //
    // #bgndVideo only exists when the hero slider is set to "Video slider".
    // It is currently on "Image slider", so there is nothing to initialise
    // either way. Both conditions are checked so this stays quiet whichever
    // mode the slider is in, and starts working by itself if the plugin is
    // ever added.
    if ($.fn.YTPlayer && $("#bgndVideo").length) {
        $("#bgndVideo").YTPlayer({
            showControls:false
        });
    }

})(jQuery);
